import React, {useCallback} from "react";

// da: https://www.30secondsofcode.org/react/s/use-key-press/
// N.B. ho provato react-hotkeys-hook, gia utilizzato in passato (AziendaSearchBar), ma nn rileva la unica pressione del ctrl (serve un hoykey!)
export const useKeyPress = (targetKey: string | null, checkIsCtrl: boolean) => {
    const [keyPressed, setKeyPressed] = React.useState(false);

    const downHandler = useCallback(({key, ctrlKey}: KeyboardEvent) => {
        if (key === targetKey || (checkIsCtrl && ctrlKey)) {
            setKeyPressed(true);
        }
    }, [targetKey, checkIsCtrl]);

    const upHandler = useCallback(({key, ctrlKey}: KeyboardEvent) => {
        if (key === targetKey || (checkIsCtrl && !ctrlKey)) {
            setKeyPressed(false);
        }
    }, [targetKey, checkIsCtrl]);

    React.useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);

        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, [downHandler, upHandler]);

    return keyPressed;
};